export const CREATE_MASTER_START='CREATE_MASTER_START';
export const CREATE_MASTER_SUCCESS='CREATE_MASTER_SUCCESS';
export const CREATE_MASTER_FAIL='CREATE_MASTER_FAIL';

export const GET_MASTERS_START='GET_MASTERS_START';
export const GET_MASTERS_SUCCESS='GET_MASTERS_SUCCESS';
export const GET_MASTERS_FAIL='GET_MASTERS_FAIL';

export const UPDATE_MASTER_START='UPDATE_MASTER_START';
export const UPDATE_MASTER_SUCCESS='UPDATE_MASTER_SUCCESS';
export const UPDATE_MASTER_FAIL='UPDATE_MASTER_FAIL';

export const SET_COMMISSION_TO_UPDATE='SET_COMMISSION_TO_UPDATE';

export const TOGGLE_BASIC_INFO_UPDATE='TOGGLE_BASIC_INFO_UPDATE';
export const TOGGLE_BET_LIMIT_UPDATE='TOGGLE_BET_LIMIT_UPDATE';
export const TOGGLE_COMMISSION_UPDATE='TOGGLE_COMMISSION_UPDATE';
export const TOGGLE_SHARE_DETAIL_UPDATE='TOGGLE_SHARE_DETAIL_UPDATE';
export const TOGGLE_SINGLE_BET_COMMISSION_UPDATE='TOGGLE_SINGLE_BET_COMMISSION_UPDATE';
export const TOGGLE_SINGLE_BET_UPDATE='TOGGLE_SINGLE_BET_UPDATE';
export const TOGGLE_EXTRA_COMMISSION_UPDATE='TOGGLE_EXTRA_COMMISSION_UPDATE';

export const GET_ONE_MASTER_START='GET_ONE_MASTER_START';
export const GET_ONE_MASTER_SUCCESS='GET_ONE_MASTER_SUCCESS';
export const GET_ONE_MASTER_FAIL='GET_ONE_MASTER_FAIL';

export const UPDATE_SUSPEND_START='UPDATE_SUSPEND_START';
export const UPDATE_SUSPEND_SUCCESS='UPDATE_SUSPEND_SUCCESS';
export const UPDATE_SUSPEND_FAIL='UPDATE_SUSPEND_FAIL';

export const RESET_PASSWORD_START='RESET_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS='RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL='RESET_PASSWORD_FAIL';
export const TOGGLE_RESET_PASSWORD_MODAL='TOGGLE_RESET_PASSWORD_MODAL';

export const UPDATE_MASTER_BALANCE='UPDATE_MASTER_BALANCE';

export const TOGGLE_2D_COMMISSION_UPDATE='TOGGLE_2D_COMMISSION_UPDATE';
export const TOGGLE_3D_COMMISSION_UPDATE='TOGGLE_3D_COMMISSION_UPDATE';
export const TOGGLE_4D_COMMISSION_UPDATE='TOGGLE_4D_COMMISSION_UPDATE';